<div class="main-content">
  <div class="container-fluid">

    <loader *ngIf="loading"></loader>

    <div *ngIf="!loading && project" class="epe-item">
      <div class="epe-summary" (click)="expand(project.id)">
        <div class="epe-id-col">
          <img class="profile-avatar"
               src="https://hsbooster.eu{{ project.picture }}"
               onerror="this.src='/assets/img/1177568.png'" alt="">
          <div class="profile-meta">
            <div class="user-name">
              <strong>{{ project.project_acronym }}</strong>
              <span *ngIf="project.name || project.surname">
                · <span *ngIf="project.version == 'v2'">{{ project.title }} </span>{{ project.name }} {{ project.surname }}
              </span>
            </div>
            <div class="user-id" *ngIf="project.organisation_type">{{ project.organisation_type }}</div>
            <div class="user-id" *ngIf="project.email">{{ project.email }}</div>
            <span class="user-id">User #{{ project.id }}</span>
          </div>
        </div>

        <div class="epe-right-col">
          <button class="btn btn-sm btn-action">
            <i class="fa" [ngClass]="selected === project.id ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            {{ selected === project.id ? 'Close' : getBtnText(project.sop_status) }}
          </button>
        </div>
      </div>

      <div *ngIf="selected === project.id" class="epe-detail">
        <project-sopcard [project]="project"></project-sopcard>
      </div>
    </div>

  </div>
</div>
